(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kc-lead-form"] && !Shopify.designMode) return;
  try {
    // A form inside an auto-scrolling slide group: stop the carousel as soon as a
  // field has focus. The slide group only pauses on mousedown/touchstart, which
  // keyboard focus and browser autofill never fire.
  document.addEventListener('focusin', function (e) {
    var form = e.target.closest('[data-kc-lead-form]');
    if (!form) return;
    var carousel = form.closest('scroll-carousel');
    if (carousel && carousel.id) {
      document.dispatchEvent(new CustomEvent('carousel:pause', { detail: { carouselId: carousel.id } }));
    }
  });

  // What was typed, and a finished sign-up, are remembered for as long as the page is
  // open (in memory only, nothing is stored). A form that the page replaces with a
  // fresh copy (the product page redraws its buy box on a model or colour change) reads
  // this back in its inline script.
  var kcLeadFormMemory = (window.kcLeadFormMemory = window.kcLeadFormMemory || { values: {}, done: {} });

  document.addEventListener('input', function (e) {
    var input = e.target.closest ? e.target.closest('[data-kc-lead-form] [data-hs-name]') : null;
    if (input && input.type !== 'hidden') kcLeadFormMemory.values[input.dataset.hsName] = input.value;
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kc-lead-form]');
    if (!form) return;
    e.preventDefault();

    var data = form.dataset;
    var root = form.closest('.kc-lead-form');
    var msg = form.querySelector('.kc-lead-form__msg');
    var honeypot = form.querySelector('.kc-lead-form__hp');
    var button = form.querySelector('button[type="submit"]');

    function show(text) {
      msg.textContent = text;
      msg.hidden = false;
    }

    msg.hidden = true;
    if (honeypot && honeypot.value) return;

    // Whatever fields the row holds (HubSpot's, or the fallback ones).
    var fields = [];
    var inputs = form.querySelectorAll('[data-hs-name]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var value = input.value.trim();
      if (input.required && !value) {
        show(data.msgRequired);
        input.focus();
        return;
      }
      if (value && input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        show(data.msgInvalid);
        input.focus();
        return;
      }
      if (value) fields.push({ objectTypeId: input.dataset.hsObject || '0-1', name: input.dataset.hsName, value: value });
    }

    if (!data.submitUrl) {
      // Only reachable in the editor / on unpublished themes (see the Liquid above).
      show('Vorschau: Das Formular ist noch nicht mit HubSpot verbunden.');
      return;
    }

    var body = { fields: fields, context: { pageUri: window.location.href, pageName: document.title } };
    var hutk = (document.cookie.match(/hubspotutk=([^;]+)/) || [])[1];
    if (hutk) body.context.hutk = hutk;

    if (data.consentId) {
      body.legalConsentOptions = {
        consent: {
          consentToProcess: true,
          text: data.consentText || '',
          communications: [
            { value: true, subscriptionTypeId: parseInt(data.consentId, 10), text: data.consentText || '' },
          ],
        },
      };
    }

    button.disabled = true;

    fetch(data.submitUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('hubspot ' + response.status);
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function (result) {
        if (data.event) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: data.event });
        }

        // HubSpot answers with what the form is set to do after a submission:
        // a redirect, or its thank-you message (rich text, shown here as text).
        if (result.redirectUri) {
          window.location.href = result.redirectUri;
          return;
        }
        var done = root.querySelector('.kc-lead-form__done');
        if (result.inlineMessage) {
          // the message is rich text in several paragraphs: a space where each block ends,
          // or the sentences run into each other ('You're in!Be among...')
          var html = result.inlineMessage.replace(/<br\s*\/?>|<\/(p|div|li|h[1-6])>/gi, '$& ');
          var text = new DOMParser().parseFromString(html, 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
          if (text) done.textContent = text;
        }
        form.hidden = true;
        done.hidden = false;
        done.focus({ preventScroll: true });
        kcLeadFormMemory.done[data.submitUrl] = done.textContent;
        kcLeadFormMemory.values = {};
      })
      .catch(function () {
        button.disabled = false;
        show(data.msgError);
      });
  });
  } catch(e) { console.error(e); }
})();

})();
